import React from 'react';
import AdminLayout from '../../../styledComponents/AdminLayout';
import Brochure from '../components/Brochure';

const tabTitleMap = {
  academics: 'Academics',
  resources: 'Resources',
  eligibility: 'Eligibility',
  'about-program': 'About Program',
  'whats-included': `What's Included`,
  'cost-and-funding': 'Cost & Funding',
  'term-information': 'Term Information',
};

export default function Page({ params }) {
  return {
    title: `Brochure | ${params.tab ? tabTitleMap[params.tab] : 'Program Overview'}`,
    component: (
      <AdminLayout
      // includedHeader={false}
      >
        <Brochure {...params} />
      </AdminLayout>
    ),
  };
}
